import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-066782f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sp-6 mx-auto" }
const _hoisted_2 = { class: "w-full mt-4" }
const _hoisted_3 = {
  key: 0,
  class: "multip-select-btn-group bg-white rounded-[50px] p-1 flex justify-between items-center gap-1 max-w-[219px] shadow-[0px_8px_30px_0px_rgba(128,140,163,0.15)] mb-10"
}
const _hoisted_4 = { class: "flex flex-row" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "ml-16 mt-2 flex flex-row"
}
const _hoisted_7 = {
  key: 0,
  class: "upload-section mt-8 rounded-[20px] shadow-[0px_8px_30px_0px_rgba(128,140,163,0.15)] py-6 px-8 text-center bg-white"
}
const _hoisted_8 = { class: "mb-6 text-[#4B5563] text-2xl font-medium" }
const _hoisted_9 = {
  key: 1,
  class: "search-and-load-section mt-8"
}
const _hoisted_10 = { class: "rounded-xl bg-white border border-[#EAECF0]" }
const _hoisted_11 = { class: "min-w-full w-full" }
const _hoisted_12 = { class: "columns" }
const _hoisted_13 = { class: "text-start pl-3" }
const _hoisted_14 = ["checked"]
const _hoisted_15 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { class: "pl-3" }
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "text-[#101828] font-medium text-sm py-6" }
const _hoisted_48 = { class: "text-[#475467] text-sm py-6" }
const _hoisted_49 = { class: "text-[#475467] text-sm py-6" }
const _hoisted_50 = { class: "text-sm text-[#475467] py-6" }
const _hoisted_51 = { class: "text-sm text-[#475467] py-6" }
const _hoisted_52 = { class: "text-sm text-[#475467] py-6" }
const _hoisted_53 = { class: "grade-block bg-[#155EEF] w-auto flex justify-between items-center py-2.5 px-5 rounded-lg my-6 mx-3" }
const _hoisted_54 = { class: "learner-count-block text-sm text-[#155EEF] bg-[#F9F5FF] py-1 px-6 rounded-lg" }
const _hoisted_55 = {
  key: 0,
  class: "mt-10"
}
const _hoisted_56 = { class: "rounded-xl bg-white border border-[#EAECF0]" }
const _hoisted_57 = { class: "min-w-full w-full preview-table" }
const _hoisted_58 = { class: "columns" }
const _hoisted_59 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { key: 1 }
const _hoisted_69 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_71 = { key: 0 }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { key: 1 }
const _hoisted_74 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { key: 1 }
const _hoisted_79 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { key: 0 }
const _hoisted_83 = { key: 1 }
const _hoisted_84 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_86 = { key: 0 }
const _hoisted_87 = { key: 0 }
const _hoisted_88 = { key: 1 }
const _hoisted_89 = { class: "text-sm text-[#101828] font-medium py-6 pl-3" }
const _hoisted_90 = { class: "text-sm text-[#475467] py-6" }
const _hoisted_91 = { class: "text-sm text-[#475467] py-6" }
const _hoisted_92 = { class: "text-sm text-[#475467] py-6" }
const _hoisted_93 = { class: "text-sm text-[#475467] py-6" }
const _hoisted_94 = { class: "text-sm text-[#475467] py-6" }
const _hoisted_95 = {
  key: 1,
  class: "mt-14"
}
const _hoisted_96 = { class: "rounded-xl bg-white border border-[#EAECF0]" }
const _hoisted_97 = { class: "text-2xl text-[#101828] font-semibold px-3 py-6 border-b border-b-2 border-[#EAECF0]" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_99 = { class: "min-w-full w-full upload-preview-table mt-4" }
const _hoisted_100 = { class: "columns" }
const _hoisted_101 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_103 = { key: 0 }
const _hoisted_104 = { key: 0 }
const _hoisted_105 = { key: 1 }
const _hoisted_106 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_108 = { key: 0 }
const _hoisted_109 = { key: 0 }
const _hoisted_110 = { key: 1 }
const _hoisted_111 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_113 = { key: 0 }
const _hoisted_114 = { key: 0 }
const _hoisted_115 = { key: 1 }
const _hoisted_116 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_118 = { key: 0 }
const _hoisted_119 = { key: 0 }
const _hoisted_120 = { key: 1 }
const _hoisted_121 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_123 = { key: 0 }
const _hoisted_124 = { key: 0 }
const _hoisted_125 = { key: 1 }
const _hoisted_126 = { class: "flex hover:cursor-pointer gap-1" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_128 = { key: 0 }
const _hoisted_129 = { key: 0 }
const _hoisted_130 = { key: 1 }
const _hoisted_131 = { class: "text-sm text-[#101828] font-medium py-6 pl-6" }
const _hoisted_132 = { class: "text-sm text-[#475467] py-6" }
const _hoisted_133 = { class: "text-sm text-[#475467] py-6" }
const _hoisted_134 = { class: "text-sm text-[#475467] py-6" }
const _hoisted_135 = { class: "text-sm text-[#475467] py-6" }
const _hoisted_136 = { class: "text-sm text-[#475467] py-6" }
const _hoisted_137 = { class: "flex justify-between items-center mt-8" }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "13",
  height: "12",
  viewBox: "0 0 13 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "me-2.5"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 6L5.75 1.25M1 6L5.75 10.75M1 6L12.0833 6",
    stroke: "#344054",
    "stroke-width": "1.58333",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_139 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_140 = {
  key: 2,
  class: "flex items-center"
}
const _hoisted_141 = {
  key: 0,
  class: "inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white me-2",
  role: "status"
}
const _hoisted_142 = ["disabled"]
const _hoisted_143 = {
  key: 0,
  class: "inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white me-2",
  role: "status"
}
const _hoisted_144 = {
  key: 2,
  class: "pagination w-full flex justify-center items-center gap-2 pt-8"
}
const _hoisted_145 = ["onClick"]
const _hoisted_146 = { key: 3 }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_148 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_149 = { class: "flex min-h-full items-end justify-center p-8 text-center sm:items-center" }
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18 6L6 18M6 6L18 18",
    stroke: "#98A2B3",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_151 = [
  _hoisted_150
]
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-auto flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
      fill: "#DCFAE6"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M19.5 24L22.5 27L28.5 21M34 24C34 29.5228 29.5228 34 24 34C18.4772 34 14 29.5228 14 24C14 18.4772 18.4772 14 24 14C29.5228 14 34 18.4772 34 24Z",
      stroke: "#079455",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_153 = { class: "mt-6 text-center" }
const _hoisted_154 = { class: "mt-4 text-center" }
const _hoisted_155 = { class: "font-normal text-sm text-[#475467] text-center mt-2" }
const _hoisted_156 = { class: "mt-6 flex justify-around items-center" }
const _hoisted_157 = { key: 4 }
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_159 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_160 = { class: "flex min-h-full items-end justify-center p-8 text-center sm:items-center" }
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18 6L6 18M6 6L18 18",
    stroke: "#98A2B3",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_162 = [
  _hoisted_161
]
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-auto flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
      fill: "#FEE4E2"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M24 20V24M24 28H24.01M34 24C34 29.5228 29.5228 34 24 34C18.4772 34 14 29.5228 14 24C14 18.4772 18.4772 14 24 14C29.5228 14 34 18.4772 34 24Z",
      stroke: "#D92D20",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_164 = { class: "mt-6 text-center" }
const _hoisted_165 = { class: "font-normal text-sm text-[#475467] text-center mt-2" }
const _hoisted_166 = { class: "flex justify-around items-center" }

import { ref, watch, computed, onMounted, onBeforeMount } from "vue";
import { useLearnerStore } from "@/stores/learnerStore";
import { useFilterStore } from "@/stores/filterStore";
import { useLicenseStore } from "@/stores/licenseStore";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import { useSchoolStore } from "@/stores/schoolStore";
import { useRoute, useRouter } from "vue-router";
import FileUploadWidgetComponent from "@/modules/main/components/FileUploadWidgetComponent.vue";
import SchoolLicenseComponent from "@/components/global/SchoolLicenseComponent.vue";

interface SelectOption {
  label: string;
  value: string;
}

// Variables
const itemsPerPage = 20;

export default /*#__PURE__*/_defineComponent({
  __name: 'InternalArchiveContentComponent',
  props: {
    showHiddenButton: {
        type: Boolean,
        required: false,
        default: false,
    }
},
  setup(__props) {

const props = __props;



const loading = ref(false);
const activeButton = ref<string | null>("archiveSelected");
const actionType = ref<string | null>("archived");
const archivemethodSelected = ref<string>();
//license refs
const learnersWithoutLicenses = ref<string[]>([]);
const showFileUploadModal = ref(false);
const confirmAssignLearnersModal = ref(false);
const currentClassGroup = ref<any>(null);
const searchQuery = ref("");
const selectedLearners = ref<string[]>([]);
const uploadedLearners = ref<any>([]);
let currentPage = ref(1);
const searchLearner = ref("");
const learnerOptions = ref<SelectOption[]>([]);
const learnersDataRaw = useLearnerStore();
const learnersData = learnersDataRaw.getAllSchoolLearners;
const uploadPreviewCard = ref(false);
let searchLoadPreviewCard = ref(false);
let archiveRequestSuccess = ref(false);
let archiveRequestFailed = ref(false);
const sortKey = ref('');
const sortOrder = ref('asc');
const sortKey2 = ref('');
const sortOrder2 = ref('asc');
const sortKey3 = ref('');
const sortOrder3 = ref('asc');

// Router and Route
const router = useRouter();
const route = useRoute();

// Data Sources
const learnerStore = useLearnerStore();
const schoolStore = useSchoolStore();
const filterStore = useFilterStore();
const licenseStore = useLicenseStore();

const isLicenseExceeded = computed(() => {
  return licenseStore.isAnyLicenseSeatsExceeded();
});

const filteredLearners = computed(() => {
  const query = searchQuery.value.toLowerCase();
  //const filteredClassGroups = filterStore.selectedFilters.classGroup;
  const filterGradeLevel = filterStore.selectedFilters.gradeLevel;
  const data = learnerStore.getAllSchoolLearners.filter((student) => {
    let typeCondition = false;
    if (activeButton.value === "archiveSelected") {
      typeCondition = (student.status === "active") ? true : false;
    } else if (activeButton.value === "unarchiveSelected") {
      typeCondition = (student.status == "archived") ? true : false;
    }
    //const isInTargetGrade = isInGradeLevel(student?.grade, filterGradeLevel);
    const matchesQuery = student.firstName.toLowerCase().includes(query) || student.lastName.toLowerCase().includes(query) || student.email.toLowerCase().includes(query);
    // if (filteredClassGroups.length === 0) {
    //   return isInTargetGrade && typeCondition && matchesQuery;
    // }
    return typeCondition && matchesQuery;
  });
  return data;
});

const setActiveButton = (button: string) => {
  selectedLearners.value = [];
  currentPage.value = 1;
  activeButton.value = button;
  actionType.value = button === "archiveSelected" ? "archived" : "unarchived";
  searchLoadPreviewCard.value = false;
  uploadPreviewCard.value = false;
}


const isInFilteredClassGroups = (studentClasses) => {
  return studentClasses;
};

const goBack = () => {

  if (props.showHiddenButton) {  
     router.push('/main/internal');
  }else {
    clearLearners();
    uploadPreviewCard.value = false;
  }

  learnerStore.setArchiveOptions(true);
};

const paginatedLearners = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage;
  const end = start + itemsPerPage;
  return filteredLearners.value.slice(start, end);
});

const totalPages = computed(() => {
  return Math.ceil(filteredLearners.value.length / itemsPerPage);
});

const toggleAll = () => {
  if (selectedLearners.value.length === filteredLearners.value.length) {
    selectedLearners.value = [];
  } else {
    selectedLearners.value = filteredLearners.value.map(
      (student) => student._id
    );
  }
};

const areAllSelected = computed(() => {
  return (
    filteredLearners.value.length > 0 &&
    selectedLearners.value.length === filteredLearners.value.length
  );
});

const selectedLearnersData = computed(() => {
  const selectedLearnersArray = Object.values(selectedLearners.value);
  const resp = filteredLearners.value.filter((learner) =>
    selectedLearnersArray.includes(learner._id)
  );
  return resp;
});

const goToPage = (page: number) => {
  currentPage.value = page;
};

const learnerCount = computed(() => {
  return selectedLearners.value.length;
});

onBeforeMount(async () => {
  const learnersData = learnerStore.getAllSchoolLearners;
  learnerOptions.value = learnersData.map((group) => {
    return {
      label: group.firstName + " " + group.lastName,
      value: group._id,
    };
  });
});

const subjects = computed(() => {
  const subjects = new Set();
  learnersData.forEach((item) => {
    item.classes?.forEach((classItem) => {
      const existingSubject = Array.from(subjects).find(
        (subject) => subject._id === classItem.subject._id
      );
      if (!existingSubject) {
        subjects.add(classItem.subject);
      }      
    });
  });
  return Array.from(subjects);
});

watch(
  () => filterStore.selectedFilters,
  async () => {
    // await learnerStore.fetchSchoolLearners(schoolStore.getCurrentSchool?._id);
    currentPage.value = 1;
    learnersData.value = learnerStore.getAllSchoolLearners;
  },
  { deep: true }
);

/**
 * Incrementing/Decrementing License count with selections
 */
watch(
  selectedLearners,
  (newVal, oldVal) => {
    //only run for unarchiving
    if (actionType.value === "archived") return;
    const addedLearners = newVal.filter((id) => !oldVal.includes(id));
    const removedLearners = oldVal.filter((id) => !newVal.includes(id));

    addedLearners.forEach((learnerId) => {
      const learner = learnerStore.getLearnerById(learnerId);
      if (learner) {
        const subjectsChecked = new Set();
        learner.classes.forEach((cls) => {
          if (!subjectsChecked.has(cls.subject._id)) {
            const licenseProduct = learner.licenseProducts?.find(
              (licenseProductId) =>
                licenseStore.getLicense?.products.some(
                  (product) =>
                    product._id === licenseProductId &&
                    product.product.subject === cls.subject._id
                )
            );
            if (!licenseProduct) {
              const product = licenseStore.getLicense?.products.find(
                (product) => product.product.subject === cls.subject._id
              );
              if (product) {
                licenseStore.incrementSchoolLicenseSeatsUsed(product._id);
                subjectsChecked.add(cls.subject._id);
                if (!learnersWithoutLicenses.value[product._id]) {
                  learnersWithoutLicenses.value[product._id] = [];
                }
                learnersWithoutLicenses.value[product._id].push(learnerId);
              }
            }
          }
        });
      }
    });

    removedLearners.forEach((learnerId) => {
      const learner = learnerStore.getLearnerById(learnerId);
      if (learner) {
        const subjectsChecked = new Set();
        learner.classes.forEach((cls) => {
          if (!subjectsChecked.has(cls.subject._id)) {
            const licenseProduct = learner.licenseProducts?.find(
              (licenseProductId) =>
                licenseStore.getLicense?.products.some(
                  (product) =>
                    product._id === licenseProductId &&
                    product.product.subject === cls.subject._id
                )
            );
            if (!licenseProduct) {
              const product = licenseStore.getLicense?.products.find(
                (product) => product.product.subject === cls.subject._id
              );
              if (product) {
                licenseStore.decrementSchoolLicenseSeatsUsed(product._id);
                subjectsChecked.add(cls.subject._id);
                const index = learnersWithoutLicenses.value[product._id]?.indexOf(learnerId);
                if (index > -1) {
                  learnersWithoutLicenses.value[product._id].splice(index, 1);
                }
              }
            }
          }
        });
      }
    });
  },
  { deep: true }
);

const receiveUploadedLearners = (learners: any) => {
  console.log("learners: ", learners);
  const filteredData = filteredLearners.value;
  const learnersEmails = learners.map((learner) => learner.email);
  const learnersInFilteredData = filteredData.filter((learner) =>
    learnersEmails.includes(learner.email)
  );
  selectedLearners.value = learnersInFilteredData.map((learner) => learner._id);
  uploadedLearners.value = learnersInFilteredData;
  uploadPreviewCard.value = true;
  searchLoadPreviewCard.value = false;
  archivemethodSelected.value = "";

  /**
   * License on Upload
   */
  learnersInFilteredData.forEach((learner: any) => {
    const fullLearnerData = learnerStore.getLearnerById(learner._id);
    if (fullLearnerData) {
      const subjectsChecked = new Set();
      fullLearnerData.classes.forEach((cls: any) => {
        if (!subjectsChecked.has(cls.subject._id)) {
          const hasLicense = fullLearnerData.licenseProducts?.some(
            (licenseProductId: string) =>
              licenseStore.getLicense?.products.some(
                (product) =>
                  product._id === licenseProductId &&
                  product.product.subject === cls.subject._id
              )
          );
          if (!hasLicense) {
            const product = licenseStore.getLicense?.products.find(
              (product) => product.product.subject === cls.subject._id
            );
            if (product) {
              licenseStore.incrementSchoolLicenseSeatsUsed(product._id);
              subjectsChecked.add(cls.subject._id);
              if (!learnersWithoutLicenses.value[product._id]) {
                learnersWithoutLicenses.value[product._id] = [];
              }
              learnersWithoutLicenses.value[product._id].push(fullLearnerData._id);
            }
          }
        }
      });
    }
  });

};

function searchLoadPreview() {
  searchLoadPreviewCard.value = true;
  uploadPreviewCard.value = false;
  archivemethodSelected.value = "";
}

const closeSuccessFailModal = () => {
  archiveRequestSuccess.value = false;
  archiveRequestFailed.value = false;
};

const submitLearnersForUnarchive = async () => {
  loading.value = true;
  const learnerEmails = selectedLearnersData.value.map((learner) => ({ email: learner.email }));
  let request = await learnerStore.bulkArchiveUnarchiveLearners("unarchive", learnerEmails);
  loading.value = false;
  if (request?.success === true) {
    archiveRequestSuccess.value = true;
    //assign licenses to the learners
    for (const productId in learnersWithoutLicenses.value) {
      if (learnersWithoutLicenses.value[productId]) {
        const learnerIds = learnersWithoutLicenses.value[productId];
        await licenseStore.bulkAssignLicenses(learnerIds, [productId]);
      }
    }
    //reset ui
    searchLoadPreviewCard.value = false;
    uploadPreviewCard.value = false;
    //fetch licenses again
    licenseStore.fetchLicenses(schoolStore.getCurrentSchool?._id);
    // Clear learners
    selectedLearners.value = [];
  } else {
    archiveRequestFailed.value = true;
  }
};

const submitLearnersForArchive = async () => {
  loading.value = true;
  const learnerEmails = selectedLearnersData.value.map((learner) => ({ email: learner.email }));
  let request = await learnerStore.bulkArchiveUnarchiveLearners("archive", learnerEmails);
  loading.value = false;
  if (request?.success === true) {
    archiveRequestSuccess.value = true;
    searchLoadPreviewCard.value = false;
    uploadPreviewCard.value = false;
    // Clear learners
    selectedLearners.value = [];
  } else {
    archiveRequestFailed.value = true;
  }
};

const clearLearners = () => {
  uploadedLearners.value = [];
  archivemethodSelected.value = "";
  console.log("I was called!.");
};

onBeforeMount(() => {
  licenseStore.fetchLicenses(schoolStore.getCurrentSchool?._id);
  const classGroupId = route.params.classId;
  currentClassGroup.value =
    schoolStore.currentSchoolStructure?.classGroups?.find(
      (classGroup) => classGroup._id === classGroupId
    );
});

watch(searchLearner, (newQuery) => {
  searchQuery.value = newQuery;
  currentPage.value = 1;
});

const sortTable = (key: string) => {
  if (sortKey.value === key) {
    sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc';
  } else {
    sortKey.value = key;
    sortOrder.value = 'asc';
  }

  paginatedLearners.value.sort((a: any, b: any) => {
    let result = 0;
    if (key === 'class') {
      const aClass = a.classes.find(cls => cls.subject._id == filterStore.selectedFilters.subject)?.name || '';
      const bClass = b.classes.find(cls => cls.subject._id == filterStore.selectedFilters.subject)?.name || '';
      if (aClass < bClass) {
        result = -1;
      } else if (aClass > bClass) {
        result = 1;
      }
    } else {
      if (a[key] < b[key]) {
        result = -1;
      } else if (a[key] > b[key]) {
        result = 1;
      }
    }
    return sortOrder.value === 'asc' ? result : -result;
  });
};

const sortTable2 = (key: string) => {
  if (sortKey2.value === key) {
    sortOrder2.value = sortOrder2.value === 'asc' ? 'desc' : 'asc';
  } else {
    sortKey2.value = key;
    sortOrder2.value = 'asc';
  }

  selectedLearnersData.value.sort((a: any, b: any) => {
    let result = 0;
    if (key === 'class') {
      const aClass = a.classes.find(cls => cls.subject._id == filterStore.selectedFilters.subject)?.name || '';
      const bClass = b.classes.find(cls => cls.subject._id == filterStore.selectedFilters.subject)?.name || '';
      if (aClass < bClass) {
        result = -1;
      } else if (aClass > bClass) {
        result = 1;
      }
    } else {
      if (a[key] < b[key]) {
        result = -1;
      } else if (a[key] > b[key]) {
        result = 1;
      }
    }
    return sortOrder2.value === 'asc' ? result : -result;
  });
};

const sortTable3 = (key: string) => {
  if (sortKey3.value === key) {
    sortOrder3.value = sortOrder3.value === 'asc' ? 'desc' : 'asc';
  } else {
    sortKey3.value = key;
    sortOrder3.value = 'asc';
  }

  selectedLearnersData.value.sort((a: any, b: any) => {
    let result = 0;
    if (key === 'class') {
      const aClass = a.classes.find(cls => cls.subject._id == filterStore.selectedFilters.subject)?.name || '';
      const bClass = b.classes.find(cls => cls.subject._id == filterStore.selectedFilters.subject)?.name || '';
      if (aClass < bClass) {
        result = -1;
      } else if (aClass > bClass) {
        result = 1;
      }
    } else {
      if (a[key] < b[key]) {
        result = -1;
      } else if (a[key] > b[key]) {
        result = 1;
      }
    }
    return sortOrder3.value === 'asc' ? result : -result;
  });
};
onMounted(() => {
  if (window.location.hash === '#unarchive') {
    actionType.value = 'unarchived';
    activeButton.value = "unarchiveSelected"
  }
});


return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (!uploadPreviewCard.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("button", {
                class: _normalizeClass(["rounded-[50px] py-2 px-6 font-semibold shadow-none outline-none transition text-sm", {
              'bg-[#155EEF] text-white transition':
                activeButton.value === 'archiveSelected',
              'text-[#6A737F] transition': activeButton.value !== 'archiveSelected',
            }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveButton('archiveSelected')))
              }, _toDisplayString(_ctx.$t("archive_flow.archive_btn")), 3),
              _createElementVNode("button", {
                class: _normalizeClass(["rounded-[50px] py-2 px-6 font-semibold shadow-none outline-none transition text-sm", {
              'bg-[#155EEF] text-white transition':
                activeButton.value === 'unarchiveSelected',
              'text-[#6A737F] transition': activeButton.value !== 'unarchiveSelected',
            }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveButton('unarchiveSelected')))
              }, _toDisplayString(_ctx.$t("archive_flow.unarchive_btn")), 3)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          (!uploadPreviewCard.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_FormKit, {
                  modelValue: archivemethodSelected.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((archivemethodSelected).value = $event)),
                  type: "radio",
                  options: [
                _ctx.$t('archive_flow.upload'),
                _ctx.$t('archive_flow.search_and_load'),
              ],
                  "wrapper-class": {
                'text-[#6A737F]': true,
              },
                  classes: {
                inner: {
                  'me-2': true,
                },
              }
                }, null, 8, ["modelValue", "options"])
              ]))
            : _createCommentVNode("", true),
          (actionType.value === 'unarchived')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(SchoolLicenseComponent, {
                  showAllLicenses: true,
                  layoutType: "horizontal"
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (archivemethodSelected.value === _ctx.$t('archive_flow.upload'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t("archive_flow.upload_header")), 1),
            (_unref(schoolStore).currentSchool)
              ? (_openBlock(), _createBlock(FileUploadWidgetComponent, {
                  key: 0,
                  uploadType: 'archive_unarchive',
                  classGroupId: currentClassGroup.value,
                  subjects: subjects.value,
                  shouldGenerateEmail: false,
                  schoolData: _unref(schoolStore).currentSchool,
                  schoolStructure: _unref(schoolStore).getSchoolStructure,
                  onCloseUploadModal: _cache[3] || (_cache[3] = ($event: any) => (showFileUploadModal.value = false)),
                  onTransmitLearnersToUpload: receiveUploadedLearners,
                  requireGrade: false,
                  lockedJourneys: false,
                  class: "max-w-3xl m-auto"
                }, null, 8, ["classGroupId", "subjects", "schoolData", "schoolStructure"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (archivemethodSelected.value === _ctx.$t('archive_flow.search_and_load'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("table", _hoisted_11, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_12, [
                    _createElementVNode("th", _hoisted_13, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        onChange: toggleAll,
                        checked: areAllSelected.value,
                        class: "h-4 w-4 border border-[#155EEF] text-[#155EEF] focus:ring-[#155EEF]"
                      }, null, 40, _hoisted_14)
                    ]),
                    _createElementVNode("th", {
                      class: "text-start text-[#475467] font-medium text-xs py-3",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (sortTable('firstName')))
                    }, [
                      _createElementVNode("span", _hoisted_15, [
                        _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.first_name")), 1),
                        _hoisted_16,
                        (sortKey.value === 'firstName'|| sortKey.value === '')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                              (sortOrder.value === 'asc')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, " ▲ "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_19, " ▼ "))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("th", {
                      class: "text-start text-[#475467] font-medium text-xs py-3",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (sortTable('lastName')))
                    }, [
                      _createElementVNode("span", _hoisted_20, [
                        _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.last_name")), 1),
                        _hoisted_21,
                        (sortKey.value === 'lastName'|| sortKey.value === '')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                              (sortOrder.value === 'asc')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_23, " ▲ "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_24, " ▼ "))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("th", {
                      class: "text-start text-[#475467] font-medium text-xs py-3",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (sortTable('grade')))
                    }, [
                      _createElementVNode("span", _hoisted_25, [
                        _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.grade")), 1),
                        _hoisted_26,
                        (sortKey.value === 'grade'|| sortKey.value === '')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                              (sortOrder.value === 'asc')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, " ▲ "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_29, " ▼ "))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("th", {
                      class: "text-start text-[#475467] font-medium text-xs py-3",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (sortTable('email')))
                    }, [
                      _createElementVNode("span", _hoisted_30, [
                        _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.email")), 1),
                        _hoisted_31,
                        (sortKey.value === 'email'|| sortKey.value === '')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                              (sortOrder.value === 'asc')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_33, " ▲ "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_34, " ▼ "))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("th", {
                      class: "text-start text-[#475467] font-medium text-xs py-3",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (sortTable('class')))
                    }, [
                      _createElementVNode("span", _hoisted_35, [
                        _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.class")), 1),
                        _hoisted_36,
                        (sortKey.value === 'class'|| sortKey.value === '')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                              (sortOrder.value === 'asc')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_38, " ▲ "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_39, " ▼ "))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("th", {
                      class: "text-start text-[#475467] font-medium text-xs py-3",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (sortTable('status')))
                    }, [
                      _createElementVNode("span", _hoisted_40, [
                        _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.status")), 1),
                        _hoisted_41,
                        (sortKey.value === 'status'|| sortKey.value === '')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                              (sortOrder.value === 'asc')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_43, " ▲ "))
                                : (_openBlock(), _createElementBlock("span", _hoisted_44, " ▼ "))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedLearners.value, (student) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: student._id,
                      class: _normalizeClass([{
                  'selected-row': selectedLearners.value.includes(student._id),
                }, "mb-1"])
                    }, [
                      _createElementVNode("td", _hoisted_45, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          value: student._id,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedLearners).value = $event)),
                          class: "h-4 w-4 border border-[#155EEF] text-[#155EEF] focus:ring-[#155EEF]"
                        }, null, 8, _hoisted_46), [
                          [_vModelCheckbox, selectedLearners.value]
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_47, _toDisplayString(student.firstName), 1),
                      _createElementVNode("td", _hoisted_48, _toDisplayString(student.lastName), 1),
                      _createElementVNode("td", _hoisted_49, _toDisplayString(student.grade), 1),
                      _createElementVNode("td", _hoisted_50, _toDisplayString(student.email), 1),
                      _createElementVNode("td", _hoisted_51, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((student.classes || []).filter(cls => cls.subject._id == _unref(filterStore).selectedFilters.subject), (classItem) => {
                          return (_openBlock(), _createElementBlock("span", {
                            class: "rounded-[50px] py-1 px-2 mr-1 shadow-none outline-none text-xs bg-[#155EEF] text-white",
                            key: classItem._id
                          }, _toDisplayString(classItem.name), 1))
                        }), 128))
                      ]),
                      _createElementVNode("td", _hoisted_52, [
                        _createElementVNode("strong", null, _toDisplayString(student.status), 1)
                      ])
                    ], 2))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, _toDisplayString(learnerCount.value) + " " + _toDisplayString(_ctx.$t("archive_flow.selected")), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(searchLoadPreviewCard) && archivemethodSelected.value === '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("table", _hoisted_57, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_58, [
                  _createElementVNode("th", {
                    class: "text-start text-[#475467] font-medium text-xs py-3 pl-3",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (sortTable2('firstName')))
                  }, [
                    _createElementVNode("span", _hoisted_59, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.first_name")), 1),
                      _hoisted_60,
                      (sortKey2.value === 'firstName'|| sortKey2.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_61, [
                            (sortOrder2.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_62, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_63, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "text-start text-[#475467] font-medium text-xs py-3",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (sortTable2('lastName')))
                  }, [
                    _createElementVNode("span", _hoisted_64, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.last_name")), 1),
                      _hoisted_65,
                      (sortKey2.value === 'lastName'|| sortKey2.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_66, [
                            (sortOrder2.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_67, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_68, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "text-start text-[#475467] font-medium text-xs py-3",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (sortTable2('grade')))
                  }, [
                    _createElementVNode("span", _hoisted_69, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.grade")), 1),
                      _hoisted_70,
                      (sortKey2.value === 'grade'|| sortKey2.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_71, [
                            (sortOrder2.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_72, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_73, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "text-start text-[#475467] font-medium text-xs py-3",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (sortTable2('email')))
                  }, [
                    _createElementVNode("span", _hoisted_74, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.email")), 1),
                      _hoisted_75,
                      (sortKey2.value === 'email'|| sortKey2.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_76, [
                            (sortOrder2.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_77, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_78, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "text-start text-[#475467] font-medium text-xs py-3",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (sortTable2('class')))
                  }, [
                    _createElementVNode("span", _hoisted_79, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.class")), 1),
                      _hoisted_80,
                      (sortKey2.value === 'class'|| sortKey2.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_81, [
                            (sortOrder2.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_82, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_83, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "text-start text-[#475467] font-medium text-xs py-3",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (sortTable2('status')))
                  }, [
                    _createElementVNode("span", _hoisted_84, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.status")), 1),
                      _hoisted_85,
                      (sortKey2.value === 'status'|| sortKey2.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_86, [
                            (sortOrder2.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_87, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_88, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedLearnersData.value, (learner) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: learner._id,
                    class: "mb-1"
                  }, [
                    _createElementVNode("td", _hoisted_89, _toDisplayString(learner.firstName), 1),
                    _createElementVNode("td", _hoisted_90, _toDisplayString(learner.lastName), 1),
                    _createElementVNode("td", _hoisted_91, _toDisplayString(learner.grade), 1),
                    _createElementVNode("td", _hoisted_92, _toDisplayString(learner.email), 1),
                    _createElementVNode("td", _hoisted_93, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((learner.classes || []).filter(cls => cls.subject._id == _unref(filterStore).selectedFilters.subject), (classItem) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "rounded-[50px] py-1 px-2 mr-1 shadow-none outline-none text-xs bg-[#155EEF] text-white",
                          key: classItem._id
                        }, _toDisplayString(classItem.name), 1))
                      }), 128))
                    ]),
                    _createElementVNode("td", _hoisted_94, [
                      _createElementVNode("strong", null, _toDisplayString(learner.status), 1)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (uploadPreviewCard.value && archivemethodSelected.value === '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("h2", _hoisted_97, _toDisplayString(actionType.value === 'archived' ? _ctx.$t("archive_flow.archive_btn") : _ctx.$t("archive_flow.unarchive_btn")) + " " + _toDisplayString(_ctx.$t("archive_flow.upload_preview_header")), 1),
            _hoisted_98,
            _createElementVNode("table", _hoisted_99, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_100, [
                  _createElementVNode("th", {
                    class: "text-start text-xs text-[#475467] font-medium py-3 pl-3",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (sortTable3('firstName')))
                  }, [
                    _createElementVNode("span", _hoisted_101, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.name")), 1),
                      _hoisted_102,
                      (sortKey3.value === 'firstName'|| sortKey3.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_103, [
                            (sortOrder3.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_104, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_105, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "text-start text-xs text-[#475467] font-medium py-3",
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (sortTable3('lastName')))
                  }, [
                    _createElementVNode("span", _hoisted_106, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.last_name")), 1),
                      _hoisted_107,
                      (sortKey3.value === 'lastName'|| sortKey3.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_108, [
                            (sortOrder3.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_109, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_110, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "text-start text-xs text-[#475467] font-medium py-3",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (sortTable3('school')))
                  }, [
                    _createElementVNode("span", _hoisted_111, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.school")), 1),
                      _hoisted_112,
                      (sortKey3.value === 'school'|| sortKey3.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_113, [
                            (sortOrder3.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_114, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_115, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "text-start text-xs text-[#475467] font-medium py-3",
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (sortTable3('grade')))
                  }, [
                    _createElementVNode("span", _hoisted_116, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.grade")), 1),
                      _hoisted_117,
                      (sortKey3.value === 'grade'|| sortKey3.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_118, [
                            (sortOrder3.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_119, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_120, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "text-start text-xs text-[#475467] font-medium py-3",
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (sortTable3('email')))
                  }, [
                    _createElementVNode("span", _hoisted_121, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.email")), 1),
                      _hoisted_122,
                      (sortKey3.value === 'email'|| sortKey3.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_123, [
                            (sortOrder3.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_124, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_125, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("th", {
                    class: "text-start text-xs text-[#475467] font-medium py-3",
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (sortTable3('class')))
                  }, [
                    _createElementVNode("span", _hoisted_126, [
                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.learners_table.class")), 1),
                      _hoisted_127,
                      (sortKey3.value === 'class'|| sortKey3.value === '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_128, [
                            (sortOrder3.value === 'asc')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_129, " ▲ "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_130, " ▼ "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadedLearners.value, (learner, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: "mb-1"
                  }, [
                    _createElementVNode("td", _hoisted_131, _toDisplayString(learner.firstName), 1),
                    _createElementVNode("td", _hoisted_132, _toDisplayString(learner.lastName), 1),
                    _createElementVNode("td", _hoisted_133, _toDisplayString(learner.school), 1),
                    _createElementVNode("td", _hoisted_134, _toDisplayString(learner.grade), 1),
                    _createElementVNode("td", _hoisted_135, _toDisplayString(learner.email), 1),
                    _createElementVNode("td", _hoisted_136, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((learner.classes || []).filter(cls => cls.subject._id == _unref(filterStore).selectedFilters.subject), (classItem) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "rounded-[50px] py-1 px-2 mr-1 shadow-none outline-none text-xs bg-[#155EEF] text-white",
                          key: classItem._id
                        }, _toDisplayString(classItem.name), 1))
                      }), 128))
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_137, [
      (__props.showHiddenButton)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[23] || (_cache[23] = ($event: any) => (goBack())),
            class: "font-semibold text-[#344054] text-base border-[#D0D5DD] border rounded-lg ms-10 py-2 px-4 flex items-center shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white"
          }, [
            _hoisted_138,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("archive_flow.back")), 1)
          ]))
        : _createCommentVNode("", true),
      (archivemethodSelected.value === _ctx.$t('archive_flow.search_and_load'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
            _createElementVNode("button", {
              onClick: _cache[24] || (_cache[24] = ($event: any) => (goBack())),
              class: "font-semibold text-[#344054] text-base border-[#D0D5DD] border rounded-lg py-2 px-4 font-medium flex items-center bg-transparent me-4 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white"
            }, _toDisplayString(_ctx.$t("archive_flow.cancel")), 1),
            _createElementVNode("button", {
              onClick: searchLoadPreview,
              class: "rounded-lg py-2 px-4 text-white flex items-center font-semibold bg-[#155EEF] shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)]"
            }, _toDisplayString(_ctx.$t("archive_flow.preview_selection")), 1)
          ]))
        : _createCommentVNode("", true),
      (
          _unref(searchLoadPreviewCard) ||
          (uploadPreviewCard.value && archivemethodSelected.value === '')
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
            _createElementVNode("button", {
              onClick: _cache[25] || (_cache[25] = ($event: any) => (goBack())),
              class: "font-semibold text-[#344054] text-base border-[#D0D5DD] border rounded-lg py-2 px-4 font-medium flex items-center bg-transparent me-4 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white"
            }, _toDisplayString(_ctx.$t("archive_flow.cancel")), 1),
            (activeButton.value == 'archiveSelected')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: submitLearnersForArchive,
                  class: "rounded-lg py-2 px-4 text-white flex items-center font-semibold bg-[#155EEF] shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)]"
                }, [
                  (loading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_141))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("archive_flow.archive_students")), 1)
                ]))
              : _createCommentVNode("", true),
            (activeButton.value == 'unarchiveSelected')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  disabled: isLicenseExceeded.value,
                  onClick: submitLearnersForUnarchive,
                  class: _normalizeClass([
            'rounded-lg py-2 px-4 text-white flex items-center font-semibold shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)]',
            isLicenseExceeded.value ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#155EEF]'
          ])
                }, [
                  (loading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_143))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("archive_flow.unarchive_students")), 1)
                ], 10, _hoisted_142))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (archivemethodSelected.value === _ctx.$t('archive_flow.search_and_load'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (page) => {
            return (_openBlock(), _createElementBlock("button", {
              key: page,
              class: _normalizeClass(["pagination-btn rounded-sm p-2 text-sm font-medium w-6 h-6 leading-none flex justify-center items-center", { 'pagination-active-btn': _unref(currentPage) === page }]),
              onClick: ($event: any) => (goToPage(page))
            }, _toDisplayString(page), 11, _hoisted_145))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_unref(archiveRequestSuccess))
      ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
          _createVNode(_unref(TransitionRoot), {
            as: "template",
            show: true
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Dialog), {
                as: "div",
                class: "relative z-40",
                onClose: _cache[26] || (_cache[26] = ($event: any) => (confirmAssignLearnersModal.value = false))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TransitionChild), {
                    as: "template",
                    enter: "ease-out duration-300",
                    "enter-from": "opacity-0",
                    "enter-to": "opacity-100",
                    leave: "ease-in duration-200",
                    "leave-from": "opacity-100",
                    "leave-to": "opacity-0"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_147
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_148, [
                    _createElementVNode("div", _hoisted_149, [
                      _createVNode(_unref(TransitionChild), {
                        as: "template",
                        enter: "ease-out duration-300",
                        "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                        "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(DialogPanel), { class: "p-8 relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", {
                                  class: "absolute top-6 right-4 cursor-pointer",
                                  onClick: closeSuccessFailModal
                                }, _hoisted_151),
                                _hoisted_152,
                                _createElementVNode("div", _hoisted_153, [
                                  _createVNode(_unref(DialogTitle), {
                                    as: "h3",
                                    class: "mt-6 font-semibold text-2xl text-[#101828]"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.modals.complete")), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_154, [
                                  _createElementVNode("p", _hoisted_155, _toDisplayString(_ctx.$t("archive_flow.modals.success_message", { type: actionType.value })), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_156, [
                                _createElementVNode("button", {
                                  onClick: closeSuccessFailModal,
                                  type: "button",
                                  class: "font-semibold text-[#344054] text-base border-[#D0D5DD] border rounded-lg py-2 px-8 mt-8 w-full"
                                }, _toDisplayString(_ctx.$t("archive_flow.modals.close")), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_unref(archiveRequestFailed))
      ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
          _createVNode(_unref(TransitionRoot), {
            as: "template",
            show: true
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Dialog), {
                as: "div",
                class: "relative z-40",
                onClose: _cache[27] || (_cache[27] = ($event: any) => (confirmAssignLearnersModal.value = false))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(TransitionChild), {
                    as: "template",
                    enter: "ease-out duration-300",
                    "enter-from": "opacity-0",
                    "enter-to": "opacity-100",
                    leave: "ease-in duration-200",
                    "leave-from": "opacity-100",
                    "leave-to": "opacity-0"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_158
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_159, [
                    _createElementVNode("div", _hoisted_160, [
                      _createVNode(_unref(TransitionChild), {
                        as: "template",
                        enter: "ease-out duration-300",
                        "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                        "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                        leave: "ease-in duration-200",
                        "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                        "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(DialogPanel), { class: "p-8 relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", {
                                  class: "absolute top-6 right-4 cursor-pointer",
                                  onClick: closeSuccessFailModal
                                }, _hoisted_162),
                                _hoisted_163,
                                _createElementVNode("div", _hoisted_164, [
                                  _createVNode(_unref(DialogTitle), {
                                    as: "h3",
                                    class: "mt-6 font-semibold text-2xl text-[#101828]"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t("archive_flow.modals.incomplete")), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_165, [
                                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("archive_flow.modals.error_message")), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_166, [
                                _createElementVNode("button", {
                                  onClick: closeSuccessFailModal,
                                  type: "button",
                                  class: "font-semibold text-[#344054] text-base border-[#D0D5DD] border rounded-lg py-2 px-8 mt-8 w-full"
                                }, _toDisplayString(_ctx.$t("archive_flow.modals.close")), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})